/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

const employeeVisibilityBase = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.employee_visibility),
  getBaseQueryKey(Query_Keys.employees),
  getBaseQueryKey(Query_Keys.employees_ignored)
);

export const employeeVisibilityMutationKeyGroups = {
  addPhoneNumber: employeeVisibilityBase,
  ignoreEmployee: employeeVisibilityBase,
  unignoreEmployee: employeeVisibilityBase,
};
